import type { BoardView } from '../board/BoardView';
import { HammerAnimation } from '../../../boosters/views/HammerAnimation';
import type { TileStackView } from '../board/TileStackView';

export class BoosterHammerView {
  public play(boardView: BoardView, stackView: TileStackView): Promise<void> {
    const { x } = stackView;
    const { particleLayer } = boardView;
    const y = stackView.y + stackView.getNextTileZOffset();

    const animation = new HammerAnimation(particleLayer, () => boardView.animateHammerHit()).props({
      parent: boardView,
      x,
      y,
    });

    const impactPromise = new Promise<void>((resolve) => {
      animation.onImpact.connect(resolve);
    });

    animation.play().then(
      () => {
        animation.destroy({ children: true });
      },
      () => {},
    );

    return impactPromise;
  }
}
